import { Attribute, Relationship, Resource } from 'json-api';
import { Translatable } from '../../translation/translatable';
import { AtomResource } from '../classes/atom-resource';
import { Enum } from './enum.resource';
import { Offer } from './offer.resource';
import { Platform } from './platform.resource';
import { Product } from './product.resource';
import { Service } from './service.resource';
import { Tag } from './tag.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import {
  PlatformConfig,
  TagConfig,
} from 'src/app/shared/tools/search/search-config';
import { AtomService } from '../atom.service';

@Resource({
  type: 'messages',
})
export class Message extends AtomResource {
  @Attribute() content?: Translatable;
  @Attribute({ key: 'type' }) messageType?: string;
  @Attribute() transport?: 'sms' | 'email';
  @Attribute() default?: boolean;
  @Attribute() disable?: boolean;

  @Relationship() enumtype?: Enum;
  @Relationship() platform?: Platform;
  @Relationship() service?: Service;
  @Relationship() product?: Product;
  @Relationship() offer?: Offer;
  @Relationship() tags?: Tag[];
}
export class MessageConfig implements ResourceConfig {
  tables = {
    options: {
      copy: true,
    },
    includes: ['platform', 'enumtype', 'tags'],
    columns: [
      {
        columnDef: 'inherited',
        displayedDatas: [
          {
            path: ['id'],
            class: 'mat-body-2',
            type: 'overwrite',
          },
        ],
        header: 'Inherited',
        displayed: true,
      },
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        displayed: true,
        sort: 'id',
      },
      {
        columnDef: 'transport',
        displayedDatas: [
          { path: ['transport'], class: 'main' },
          { path: ['platform.name'], class: 'main' },
        ],
        header: 'Transport / Platform',
        displayed: true,
      },
      {
        columnDef: 'message',
        displayedDatas: [
          { path: ['enumtype.label'], class: 'main' },
          { path: ['content'], class: 'main' },
        ],
        header: 'Message',
        displayed: true,
        options: {
          overloadable: {
            create: Message,
            type: 'message',
            formControl: 'content',
            APIKey: 'content',
            inheritDatas: [{ key: 'product' }],
            displayedDatas: [
              {
                path: ['content'],
                class: 'mat-body-2',
              },
            ],
          },
        }
      },
      {
        columnDef: 'default',
        displayedDatas: [{ path: ['default'], class: 'main', type: 'boolean' }],
        header: 'Default',
        displayed: true,
      },
      {
        columnDef: 'disable',
        displayedDatas: [
          { path: ['disable'], class: 'main', type: 'boolean' },
        ],
        header: 'Disable',
        displayed: true,
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'message',
      title: [
        {
          path: ['transport', 'enumtype.label'],
          translatable: false,
        },
      ],
      id: true,
    },
    elements: [
      {
        showEmpty: true,
        list: [
          {
            icon: 'textsms',
            title: 'Transport',
            APIKey: 'transport',
            value: {
              path: ['transport'],
            },
          },
          {
            icon: 'outbox',
            title: 'Type',
            APIKey: 'enumtype',
            value: {
              path: ['enumtype.label'],
            },
          },
          {
            icon: 'dns',
            title: 'platform',
            APIKey: 'platform',
            value: {
              path: ['platform.name'],
            },
            link: {
              resource: 'platforms',
              filter: 'platform.id',
            },
          },
          {
            icon: 'settings',
            title: 'Default',
            APIKey: 'default',
            value: {
              path: ['default'],
              type: 'boolean',
            },
          },
          {
            icon: 'settings',
            title: 'Disable',
            APIKey: 'disable',
            value: {
              path: ['disable'],
              type: 'boolean',
            },
          },
          {
            icon: 'tag',
            title: 'Tags',
            APIKey: 'tags',
            value: {
              path: ['name'],
              type: 'chips',
            },
          },
          {
            title: 'Content',
            APIKey: 'content',
            value: {
              path: ['content'],
              type: 'multilang',
            },
          },
        ],
      },
    ],
  };
  wizard = {
    noSummary: true,
    inheritDatas: ['service', 'product', 'offer'],
    noEditWhenInherit: true,
    tabs: [
      {
        title: 'Message',
        formGroup: 'message',
        list: [
          {
            type: 'fixlist',
            title: 'Transport',
            formControl: 'transport',
            APIKey: 'transport',
            required: true,
            fixlistValues: [
              { code: 'sms', label: 'SMS' },
              { code: 'email', label: 'Email' },
            ],
            noCols: true,
          },
          {
            type: 'enum',
            title: 'Type',
            formControl: 'messageType',
            APIKey: 'messageType',
            fieldKey: 'type',
            required: true,
          },
          {
            type: 'resource',
            title: 'Platform',
            formControl: 'platform',
            APIKey: 'platform',
            search: new PlatformConfig(this.atom),
            required: true,
          },
          {
            type: 'message',
            title: 'Content',
            formControl: 'content',
            APIKey: 'content',
            translatable: true,
            required: true,
            noCols: true,
          },
          {
            type: 'boolean',
            title: 'Default',
            formControl: 'default',
            APIKey: 'default',
            required: true,
          },
          {
            type: 'boolean',
            title: 'Disable',
            formControl: 'disable',
            APIKey: 'disable',
          },
          {
            type: 'resource',
            title: 'Tags',
            formControl: 'tags',
            APIKey: 'tags',
            search: new TagConfig(true),
            multiple: true,
            required: false,
            noCols: true,
          },
        ],
      },
    ],
  };
  resource = Message;
  resourceName = 'Message';
  resourceKey = 'messages';
  resourceKeySingle = 'message';
  includes = ['platform.job.firm', 'service', 'product.country', 'enumtype', 'tags'];
  constructor(private atom: AtomService, public hosted: string = 'product') {}
}
